/* eslint-disable default-case */
import produce from 'immer';
import { listEmails, updateEmails } from './actions';

const initialState = {
  error: null,
  items: [],
  loading: false,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case updateEmails.TRIGGER:
    case listEmails.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case updateEmails.FAILURE:
    case listEmails.FAILURE:
      draft.error = payload;
      break;
    case updateEmails.SUCCESS:
    case listEmails.SUCCESS:
      draft.items = payload;
      break;
    case updateEmails.FULFILL:
    case listEmails.FULFILL:
      draft.loading = false;
      break;
  }
}, initialState);

export default reducer;
